import { get } from "lodash";
import format from "string-template";
import Card from "./Card";
const TRACERS = {
  AURA_TER: "Ma mutuelle Région Auvergne-Rhône-Alpes Agents Territoriaux",
};
const EmailTemplate = ({
  civility,
  lastName,
  firstName,
  adminPhoneNumber,
  adminFirstName,
  adminLastName,
  translation,
  costs,
  addLinks,
  offerName,
  tracer,
}) => {
  const documents = [
    translation.DOCUMENT_1,
    translation.DOCUMENT_2,
    translation.DOCUMENT_3,
    translation.DOCUMENT_4,
    translation.DOCUMENT_5,
    translation.DOCUMENT_6,
    translation.DOCUMENT_7,
    translation.DOCUMENT_8,
  ];

  return (
    <div className="quote-template-miltis__main-container">
      <div className="quote-template-miltis__header">
        <img
          src="https://assets.kayros.tech/miltis/logo.png"
          alt="Miltis Mutuelle Logo"
        />
      </div>
      <div className="quote-template-miltis__container">
        <div className="quote-template-miltis__content">
          <p>
            {translation.HELLO} {translation[civility] || civility} {firstName}{" "}
            {lastName},
          </p>
          <p
            dangerouslySetInnerHTML={{
              __html: format(translation.P1, {
                offerName:
                  TRACERS[get(tracer, "destination")] ||
                  "Ma mutuelle Région Auvergne-Rhône-Alpes",
              }),
            }}
          />
        </div>
        <div className="quote-template-miltis__formulas">
          {costs.map(({ id, insurancePlan, cost, currency }, index) => (
            <Card
              key={id}
              insurancePlan={insurancePlan}
              cost={cost}
              currency={currency}
              translation={translation}
              index={index}
              addLinks={addLinks}
            />
          ))}
        </div>
        <div className="quote-template-miltis__content">
          <p>
            <b>{translation.ATTACHED_DOCUMENTS_TITLE}</b>
          </p>
        </div>
        <div className="quote-template-miltis__content">
          <div className="quote-template-miltis__documents">
            <div className="quote-template-miltis__documents--column">
              {documents.slice(0, 3).map((doc, index) => (
                <div key={index} className="quote-template-miltis__document">
                  <span className="quote-template-miltis__document--icon">
                    <img
                      src="https://img.icons8.com/parakeet-line/16/document.png"
                      alt="Document Icon"
                    />
                  </span>
                  <span className="quote-template-miltis__document--link">
                    {doc}
                  </span>
                </div>
              ))}
            </div>
            <div className="quote-template-miltis__documents--column">
              {documents.slice(3, 6).map((doc, index) => (
                <div
                  key={index + 3}
                  className="quote-template-miltis__document"
                >
                  <span className="quote-template-miltis__document--icon">
                    <img
                      src="https://img.icons8.com/parakeet-line/16/document.png"
                      alt="Document Icon"
                    />
                  </span>
                  <span className="quote-template-miltis__document--link">
                    {doc}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="quote-template-miltis__content">
          <p>{translation.TERMINATION_INFO}</p>
        </div>
        <div className="quote-template-miltis__content">
          <p
            dangerouslySetInnerHTML={{
              __html: format(translation.CONTACT_INFO, {
                phoneNumber: "04 27 85 27 87",
                email: "contact@miltis.fr",
              }),
            }}
          />
        </div>
        <div className="quote-template-miltis__content">
          <p>{translation.CLOSING}</p>
        </div>
        <div className="quote-template-miltis__info">
          <p className="quote-template-miltis__info--text">
            {translation.YOUR_ADVISOR}
          </p>
          <p className="quote-template-miltis__info--name">
            {adminFirstName} {adminLastName}
          </p>
          <p>{adminPhoneNumber}</p>
        </div>
      </div>
    </div>
  );
};

export default EmailTemplate;
